export const PAXEL_STATUS_MAP = {
  RTP: "Courier sedang menuju lokasi pickup",
  COL: "Courier telah tiba di lokasi pickup",
  PRJL: "Pickup dibatalkan oleh courier",
  RAP: "Percobaan pickup ulang",
  PAPV: "Courier telah mengambil paket",
  POL: "Paket dalam perjalanan",
  ODL: "Courier telah tiba di locker tujuan",
  POD: "Courier sedang menuju tujuan",
  COD: "Courier telah tiba di tujuan",
  PDO: "Pengiriman selesai",
  UNDLM: "Pengiriman gagal",
  HAPH: "Ditahan di Paxel Home",
  RTN: "Paket dikembalikan",
  CCS: "Pengiriman di cancel"
}